import { JSX } from 'react';

export type CarouselProps<T> = {
    items: T[];
    renderItem: (item: T, index: number) => React.ReactNode | JSX.Element;
    keyExtractor: (item: T, index: number) => string | number;
    className?: string;
    isLoading?: boolean;
    skeletonItems?: unknown[];
    renderSleketonItem?: (item: unknown, index: number) => React.ReactNode | JSX.Element;
    skeletonKeyExtractor?: (item: unknown, index: number) => string | number;
};

export enum ScrollDirection {
    Left,
    Right,
}
